import Constants from '@/js/constants';
import EventBus from '@/js/event-bus';
import Request from '@/js/request';
import Utils from '@/js/utils';

const c = Constants.data();

export default {
  state: {
    termObject: null,
    termSchema: null,
    searchedResults: null,
    searchedResultsCount: null,
    termNameMap: {},
    downloadURL: null,
    downloadQuery: null
  },
  mutations: {
    setPagination(state, parameters) {
      state.termObject[c.PPT_RELATIONSHIPS][parameters['edge']][
        parameters['vertex']
      ] = parameters['response_body'];
    },
    setTermSchema(state, response_body) {
      if (response_body === undefined) {
        state.termObject = null;
        state.termSchema = null;
        return;
      }
      // Assign schema
      let schema = response_body['schema'];
      schema[c.PPT_ATTRIBUTES].sort(function (a, b) {
        return a.order - b.order;
      });
      schema[c.PPT_RELATIONSHIPS].sort(function (a, b) {
        return a.order - b.order;
      });
      state.termSchema = schema;
      // Assign Term
      this.commit('setTerm', response_body['term']);
    },
    setTerm(state, term) {
      if (term === undefined) {
        state.termObject = null;
        return;
      }
      state.termObject = term;
    },
    setSearchedResults(state, response_body) {
      if (response_body === undefined) {
        state.searchedResults = null;
        state.searchedResultsCount = null;
      } else {
        state.searchedResults = response_body['items'];
        state.searchedResultsCount = response_body['count'];
      }
    },
    setTermNameMap(state, response_body) {
      let termNameMap = {};
      response_body['items'].forEach(entryObj => {
        termNameMap[entryObj[c.PPT_ID]] = entryObj;
      });
      state.termNameMap = termNameMap;
      EventBus.$emit('TermNameMapUpdated');
    }
  },
  actions: {
    setSchema({ state }, schema) {
      state.termSchema = schema;
    },
    async getTermById({ commit }, parameters) {
      let parameters_ = {};
      const site = parameters['locale'] || parameters['cosmosSite'];
      if (site !== undefined && site !== null && site !== '') {
        parameters_['locale'] = site;
      }
      const response_body = await Request.get(
        `/term/${parameters['termId']}`,
        parameters_,
        parameters['refresh']
      );
      commit('setTermSchema', response_body);
    },
    async getRelationshipPagination({ commit }, parameters) {
      let parameters_ = {};
      parameters_['start'] = parameters['start'] - 1;
      parameters_['end'] = parameters['end'];
      parameters_['edge'] = parameters['edge'];
      parameters_['vertex'] = parameters['vertex'];
      const site = parameters['locale'] || parameters['cosmosSite'];
      if (site !== undefined && site !== null && site !== '') {
        parameters_['locale'] = site;
      }
      const query = `/term/${parameters['id']}`;
      const response_body = await Request.get(
        query,
        parameters_,
        parameters['refresh']
      );
      parameters_['response_body'] = response_body;
      commit('setPagination', parameters_);
    },
    async advancedSearch({ state, commit, dispatch }, parameters) {
      const parameters_ = processSearchQuery(parameters);
      if (Object.keys(parameters_).length == 0) return;

      if (!parameters.hasOwnProperty('name.like')) parameters['name.like'] = '';

      const response_body = await Request.get('/search', parameters_);
      state.downloadURL = null;
      commit('setSearchedResults', response_body);
    },

    async downloadSearchResult({ state }, parameters) {
      if (
        state.downloadURL !== null &&
        state.downloadQuery === parameters['download']
      )
        return;
      const parameters_ = processSearchQuery(parameters);
      if (Object.keys(parameters_).length == 0) return;
      if (state.searchedResultsCount !== null) {
        parameters_['start'] = 0;
        parameters_['end'] = state.searchedResultsCount;
      }
      const response_body = await Request.get('/search', parameters_);
      state.downloadURL = response_body;
      state.downloadQuery = parameters_['download'];
    },

    clearSearchResult({ state }) {
      state.searchedResultsCount = null;
      state.searchedResults = null;
    },

    async getEntriesName({ commit }, entryIds) {
      if (!entryIds || entryIds === '') return;
      const response_body = await Request.get('/search', {
        start: 0,
        end: 200,
        id: entryIds
      });
      commit('setTermNameMap', response_body);
    },

    async addEntry({ commit, dispatch }, parameters) {
      let parameters_ = {};
      parameters_['relationships'] = parameters['relationships_add'];
      parameters_['relationships_delete'] = parameters['relationships_delete'];
      parameters_['attributes'] = parameters['attributes'];
      parameters_['label'] = parameters['label'];
      const response_body = await Request.post('/term', parameters_);
      commit('setTerm', response_body);
      if (response_body !== undefined) {
        Utils.methods.notifySuccess('Term Entry Added.');
      }
    },

    async updateEntry({ commit, dispatch }, parameters) {
      const parameters_ = {};
      if (parameters.hasOwnProperty('relationships_add')) {
        parameters_['relationships'] = parameters['relationships_add'];
      }
      if (parameters.hasOwnProperty('relationships_delete')) {
        parameters_['relationships_delete'] =
          parameters['relationships_delete'];
      }
      if (parameters.hasOwnProperty('attributes')) {
        parameters_['attributes'] = parameters['attributes'];
      }
      parameters_['label'] = parameters['label'];
      const response_body = await Request.put(
        `/term/${parameters['id']}`,
        parameters_
      );
      commit('setTerm', response_body);
      if (response_body !== undefined) {
        Utils.methods.notifySuccess('Term Entry Updated.');
      }
    },

    async deleteEntry({ commit }, entryId) {
      const response_body = await Request.delete(`/term/${entryId}`);
      if (response_body !== undefined) {
        Utils.methods.notifySuccess('Term Entry Deleted.');
        commit('setTermSchema', undefined);
      }
    }
  }
};

function processSearchQuery(parameters) {
  const parameters_ = {};
  for (let key in parameters) {
    if (
      parameters[key] !== null &&
      parameters[key] !== undefined &&
      parameters[key] !== ''
    ) {
      parameters_[key] = parameters[key];
    }
  }
  return parameters_;
}
